module.exports = __webpack_public_path__ + "img/interactive_buttons2.05b88873.png";